/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeScheduleReport = {
    properties: {
        employeeId: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        totalHours: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
    },
};